import { gql } from '../../__generated__/gql'

export const SIGN_OUT_MUTATION = gql(`
  mutation signOut {
    signOut(input: {}) {
      clientMutationId
    }
  }
`)
